import {Pipe, PipeTransform} from '@angular/core';

/**
 * @author Sasi Kesani
 */
@Pipe({
    name: 'cstTime',
    standalone: false
})
export class CstTimePipe implements PipeTransform {

  /**
   *  checking if the time is in day light savings
   */
  static isDST(d) {
    const jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== d.getTimezoneOffset();
  }

  /**
   *  returns CST time
   */
  transform(timestamp: any, args?: any): any {
    const d = new Date(timestamp);
    const localTime = d.getTime();
    const localOffset = d.getTimezoneOffset() * 60000;
    const  utc = localTime + localOffset;
    // adding -5 cdt offset -6 cst
    const   offset = CstTimePipe.isDST(d) ? -5 : -6;
    const  cst = utc + (3600000 * offset);
    const   nd = new Date(cst);
    return  (nd.toLocaleString());
    /*      return moment(timestamp, ['MM/DD/YYYY, h:mm:ss a', 'YYYY/MM/DD, h:mm:ss a']).format('MM/DD/YYYY, h:mm:ss a');
            import * as moment from 'moment-timezone'
            return moment.tz(timestamp, 'America/Chicago').format('MM/DD/YYYY, h:mm:ss a');*/

  }

}
